export enum NotificationDrawerStatusEnum {
  createNotification = 'CREATE_NOTIFICATION',
  preview = 'PREVIEW',
}
